import React from 'react'
import { FieldProps } from '../FormDuuf'

const errorMessages: any = {
  required: 'Is verplicht',
  email: 'E-mail adres niet juist',
  consent: 'U dient akkoord te gaan met de voorwaarden',
  default: 'Er ging iets mis'
}

const Error: React.FC<FieldProps> = ({ formik, hasError, fieldId, data }) => {
  if (!hasError) {
    return null
  }

  return (
    <div className={`form-duuf-error form-duuf-error-${data.type}`}>{errorMessages[formik.errors[fieldId]] || formik.errors[fieldId]}</div>
  )
}

export default Error
